import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .booking-user-edit-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
  }
  .booking-user-edit-modal-inputs {
    width: 100%;
  }
  .booking-user-edit-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .booking-user-edit-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .booking-user-edit-modal :global(.submit-button:hover) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .booking-user-edit-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .booking-user-edit-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
